import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class OutgoingDialogDirectives extends Component {

  constructor() {
    super(...arguments);
    this.dialogClose = () => {
      this.setState({
        hideDialog: false, hideAddDialog: false, hideDeletePopup: false, hideDeleteAllPopup: false, hideIncorrectPassword: false
      });
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };
    this.IncorrectPassworddialogClose = () => {
      this.setState({ hideIncorrectPassword: false });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };


    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchDialogDirAjax()
        this.dialogClose();
      }
    }];


    //for add dialog component ok click
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchDialogDirAjax()
        this.dialogClose();
        this.setState({ disabled: false })

      }
    }];


    //for delete dialog component yes or no and ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteOutgoingDialgDirApi(this.state.propsId)
      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ hideDeletePopup: false });
      }
    }];

    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {

        this.dialogInstance.hide();
        this.fetchDialogDirAjax()
      }
    }];

    //deleteall
    this.deleteAllButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },

      'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
          hideTextAreaPopup: true
        });
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
        });
      }
    }];

    //incorrectPasswordButtons
    this.incorrectPasswordButtons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideTextAreaPopup: true,
          hideIncorrectPassword: false

        })
      }
    }];

    //deleteall text confirmation
    this.textAreaConfir = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.deleteInputValidation()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideTextAreaPopup: false,
        });
      }
    }];


    this.state = {
      value: '',
      pageNum: null,
      data: [{
        id: '',
        text: '',
        language: [],
        dmOutputType: []
      }],
      hideTextAreaPopup: false,
      hideIncorrectPassword: false,
      hideDeleteAllPopup: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit2.png',
      contentEditable: "false",
      showStore: false,
      showPwd: false,
      viewedId: '-1',
      hideDialog: false,
      hideAddDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      disabled: false,
      successResp: false

    };
    this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.currentSrc = "";
    this.projectId = "";
    this.language = "";
    this.ddtype = "";
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchLanguageApi();
      this.fetchdirectiveTypeApi();
      this.projectId = localStorage.getItem('currentProjectId');
      this.language = document.getElementById('languageIdDropDown').value;
      this.ddtype = document.getElementById('directiveType').value;
      this.fetchDialogDirAjax();
    }, 300);
    var thisController = this;

    document.addEventListener("projectChanged", function (event) {
      if (document.getElementById('languageIdDropDown') != null &&
        document.getElementById('directiveType') != null) {
        thisController.projectId = event.projectId;
        thisController.fetchLanguageApi(event.projectId);
        thisController.fetchdirectiveTypeApi();
        thisController.projectId = localStorage.getItem('currentProjectId');
        thisController.language = document.getElementById('languageIdDropDown').value;
        thisController.ddtype = document.getElementById('directiveType').value;
        thisController.fetchDialogDirAjax(event.projectId);
      }
    });


  }


  saveOutgoingDialogDirApi(props, e) {

    props.original.text = document.getElementById('text' + props.index).innerText.trim();
    props.original.language = document.getElementById('languageIdDropDown').value;
    props.original.dmOutputType = document.getElementById('directiveType').value;

    this.state.editedId = "-1";
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.text,
      props.original.language, props.original.dmOutputType);
    if (validateResult == true) {
      var updatedData = {

        text: props.original.text,
        language: props.original.language,
        dmOutputType: props.original.dmOutputType,
        projectId: localStorage.getItem('currentProjectId')

      };
      var addApiController = this;
      $.ajax({
        url: "/api/output-dialog-directive",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },

        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {

            addApiController.notifyAdded();
            addApiController.fetchDialogDirAjax();
            addApiController.setState({
              disabled: false
            })


          } else {
            addApiController.notifyFailedLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      })
    }
  }

  notifyAdded() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Dialog Directive Added Successfully</b>, {
      position: "top-center",

    });
  }

  notifyFailedAdd() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{
      paddingRight: '0px', height: '20px',
      width: '20px'
    }} content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }

  deleteInputValidation = () => {
    if (document.getElementById('deleteInputFromUser').value == "Delete" ||
      document.getElementById('deleteInputFromUser').value == "delete" ||
      document.getElementById('deleteInputFromUser').value == "DELETE") {
      document.getElementById('deleteInputFromUser').value = "";
      this.deleteAllOutgoingDialogDirectiveApi();
    }
    else {
      this.setState({
        hideIncorrectPassword: true
      })
    }
  }

  notifyNodata(response) {
    this.setState({
      hideTextAreaPopup: false
    })
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }


  //---------------Delete all------------------------//
  deleteAllOutgoingDialogDirectiveApi = () => {
    let deleteApiViewController = this;
    $.ajax({
      url: "/api/outgoing-dialog-directive-delete-all",
      async: false,
      method: 'POST',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      data: {
        projectId: localStorage.getItem('currentProjectId'),
        language: document.getElementById('languageIdDropDown').value
      },
      success: function (res) {
        if (res.success === true && res.result == "done.") {
          deleteApiViewController.state.hideTextAreaPopup = false;
          deleteApiViewController.setState(deleteApiViewController.state);
          deleteApiViewController.fetchDialogDirAjax();
          deleteApiViewController.notifyDeleteAllSuccess();
        } else if (res.success === true && res.result != "done.") {
          deleteApiViewController.notifyNodata(res.result);
        } else {
          deleteApiViewController.notifyFailedDelete(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }

  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });


  }

  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;All Outgoing Dialog Directives have been deleted Successfully</b>, {
      position: "top-center",
    });

  }

  updateOutgoingDialogDirApi(props, e) {
    this.state.editedId = "-1";
    props.original.text = document.getElementById('text' + props.index).innerText.trim();
    var validateResult = this.validateCells(props.original.text,
      props.original.language, props.original.dmOutputType);
    var updatedData = {
      id: props.original.id,
      text: props.original.text,
      language: document.getElementById('languageIdDropDown').value,
      dmOutputType: document.getElementById('directiveType').value,
      projectId: localStorage.getItem('currentProjectId'),

    };

    var updateController = this
    if (validateResult == true) {
      $.ajax({
        url: "/api/output-dialog-directive",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updateController.notifyUpdate();
            updateController.fetchDialogDirAjax();

          }
          else {
            updateController.notifyFailedLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
  }
  notifyUpdate() {
    toast.dismiss();
    toast(<b ><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Dialog Directive Updated Successfully</b>, {
      position: "top-center",

    });
  }


  notifyFailedUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }





  deleteOutgoingDialgDirApi = (id) => {
    var deleteConstructorVariables = this;
    let deleteApiViewController = this;
    $.ajax({
      url: "/api/output-dialog-directive/" + id,
      async: false,
      method: 'DELETE',
      headers: {
        "Authorization": "Bearer " +
          localStorage.getItem("access_token")
      },
      success: function (res) {
        if (res.success === true) {
          deleteApiViewController.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteApiViewController.notifyDelete();

        } else {
          deleteConstructorVariables.notifyFailedLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }


    });
    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchDialogDirAjax();
  }


  notifyDelete() {
    toast.dismiss();
    toast(<b ><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Dialog Directive Deleted Successfully</b>, {
      position: "top-center",

    });

  }

  notifyFailedDelete() {
    toast.dismiss();
    toast(<b ><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }



  fetchDialogDirAjax = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var fetchApiController = this;
    var validateResult = fetchApiController.dataMissing(this.projectId,
      this.language,
      this.ddtype);
    if (validateResult == true) {
      $.ajax({
        url: "/api/output-dialog-directive",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")

        },
        data: {
          projectId: projectId,
          language: document.getElementById('languageIdDropDown').value,
          dmOutputType: document.getElementById('directiveType').value
        },

        success: function (res) {
          if (res.success === true) {
            fetchApiController.setState({
              data: res.result,
              successResp: true,
              disabled: false
            });

          } else {
            fetchApiController.setState({
              successResp: false
            });
            fetchApiController.notifyFailedLoad(res.result);
          }
        },

        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
    }
    else {
      fetchApiController.setState
        ({
          successResp: true
        });
    }

  }

  notifyFailedLoad(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{
      paddingRight: '0px',
      height: '20px', width: '20px'
    }} content="" />{response}</b>, {
      position: "top-center"
    });
  }

  fetchLanguageApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var languageController = this;
    $.ajax(
      {
        url: "/api/project-languages-selected",
        async: false,
        method: 'GET',
        data: {
          projectId: projectId,
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        success: function (res) {
          if (res.success === true) {
            var language = res.result;
            languageController.setState({ language: language });
            var numberOfLanguages = language.length;
            var ele3 = document.getElementById("languageIdDropDown");
            if (ele3 != "") {
              if (ele3 != null) {
                ele3.innerHTML = "";


                for (var i = 0; i < numberOfLanguages; i++) {
                  ele3.innerHTML = ele3.innerHTML + '<option value="' +
                    language[i]['code'] + '">' + language[i]['name'] + '</option>';
                }
              }
            }
          }


          else {
            languageController.notifyFailedLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }


      }
    )


  }
  notifyFailedLoadLang() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }



  fetchdirectiveTypeApi() {
    var domainController = this;
    var responseData = []
    $.ajax(
      {
        url: "/api/outputDD-types",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        success: function (res) {
          if (res.success === true) {
            responseData = res.result;

            domainController.setState({ namedEntity: responseData });
            var numberOfnamedEntity = responseData.length;
            var ele3 = document.getElementById("directiveType");
            if (ele3 != "") {
              if (ele3 != null) {
                ele3.innerHTML = "";

                for (var i = 0; i < numberOfnamedEntity; i++) {
                  ele3.innerHTML = ele3.innerHTML + '<option value="' +
                    responseData[i]['value'] +
                    '">' + responseData[i]['key'] + '</option>';
                }
              }
            }
          }
          else {
            domainController.notifyFailedLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }



      }
    )
    if (document.getElementById('directiveType') != null) {
      let valueOfdirectiveType = document.getElementById('directiveType').value;

      this.setState({ directiveTypeId: valueOfdirectiveType })
    }
  }


  notifyFailedLoadDialDir() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }

  dataMissing(projectId, language, directiveType) {
    if (projectId == "" || projectId == null) {
      this.notifyProjectIdDataMissing();
      return false;
    }
    else if (language == "" || language == null) {

      this.notifyLanguageDataMissing();
      return false;
    }
    else if (directiveType == "" || directiveType == null) {

      this.notifyDirectiveTypeDataMissing();
      return false;
    }
    else {

      return true;
    }
  }

  notifyProjectIdDataMissing() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please select a project</b>, {
      position: "top-center"
    });
  }
  notifyLanguageDataMissing() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please select a language</b>, {
      position: "top-center"
    });
  }
  notifyDirectiveTypeDataMissing() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please select a dialog directive type</b>, {
      position: "top-center"
    });
  }

  addRow = (data) => {
    var rowController = this;
    if (rowController.state.pageNum != 0) {
      rowController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      text: ''

    });
    this.setState({
      data: this.state.data,
      disabled: true
    })
  }
  editCell(props, e) {
    this.currentSrc = this.src;
    this.markAsBeingEdited(props.original.id);
  }

  markAsBeingEdited(id) {

    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);

  }


  notifyEmptyFields() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please fill all the data</b>, {
      position: "top-center"
    });
  }

  addNewRow = () => {
    var stateObj = this.state;
    stateObj.data.push({
      text: "",
      projectId: localStorage.getItem('currentProjectId'),
      language: document.getElementById('languageIdDropDown').value,
      dmOutputType: document.getElementById('directiveType').value
    });
    stateObj.contentEditable = true;
    this.setState(stateObj);
  }

  validateCells(text, language, dmOutputType) {
    if (text == "" || language == null ||
      dmOutputType == null) {
      this.notifyEmptyFields();
      return false;
    }

    else {
      return true;
    }
  }

  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.fetchDialogDirAjax();
    this.state.disabled = false
  }

  dialogDirhandleChange = (e) => {
    this.fetchDialogDirAjax();
  }
  langhandleChange = (e) => {
    this.fetchDialogDirAjax();
  }
  textHandleChange(event, props) {

    this.state.data[props.index].text = document.getElementById("text" + props.index).innerText;
    this.setState(
      this.state);

  }
  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  render() {
    const { data } = this.state


    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          timeout={3000}
          style={{ textAlign: 'center' }}
        />
        <div className="container-fluid" style={{ display: this.state.successResp ? 'block' : 'none' }}>
          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/* for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta httpEquiv="x-ua-compatible" content="ie=edge" />
          <div style={{ backgroundColor: '#F9F9FB' }}>
            <div className="row">

            </div>



            <div className="row">
              {/* language */}
              <div className="col-sm-4">
                <h6 className="taglineTxt"></h6>
                <label style={{ marginLeft: '20px' }}>Language</label>
                <select
                  id="languageIdDropDown" className="languageIdDropDown"
                  onChange={this.langhandleChange} placeholder="Select language"
                  style={{
                    width: '50%', height: '30px', borderRadius: '4px',
                    backgroundColor: '#F9F9FB',
                    marginLeft: '35px'
                  }} >

                </select>
              </div>


              {/* Directive types*/}
              <div className="col-sm-4">
                <h6 className="taglineTxt"></h6>
                <label>Directive Types</label>
                <select
                  id="directiveType" className="directiveType"
                  onChange={this.dialogDirhandleChange}
                  placeholder="Select Dialog Directive"
                  style={{
                    width: '50%', height: '30px', borderRadius: '4px',
                    backgroundColor: '#F9F9FB', marginLeft: '10px'
                  }}>

                </select>
              </div>
            </div>


            <div className="row">
              <div className="col-sm-6">

                <h6 className="nav-item" style={{ color: '#282a65', marginLeft: '21px', marginTop: '24px' }}>
                  Outgoing Dialog Directive</h6>

              </div>
              <div className="col-sm-6" Align='right'>
                {/* <button className="btn action-button"
                  id="addMsg" title="Delete All "
                  onClick={() => {
                    this.setState({
                      hideDeleteAllPopup: true
                    })
                  }}>Delete All
                </button> */}
                <button className="btn action-button "
                  id="addMsg" onClick={this.state.disabled ? this.notifyEmptyFields : this.addRow}
                  title="Add">
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button onClick={this.refreshData} className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png" title="Refresh"></img>
                </button></div>
            </div>
          </div>

          <div id="reactTable" style={{ marginLeft: "20px" }}>
            {this.contentEditiable}
            <ReactTable id='reactTable'
              onPageChange={this.onPageChange}
              page={this.state.pageNum}

              data={data}
              columns={[
                {
                  Header: <b>Text</b>,
                  accessor: 'text',
                  sortable: false,
                  filterable: false,
                  Cell: props => (
                    <div
                      Align="left" className="input"
                      style={{
                        padding: '8px', width: '98%', borderBottom: 'none',
                        border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
                          '1px solid #D2D4DC' : 'none', borderRadius:
                          (props.original.id == undefined) ? '2px' : 'none', paddingLeft: '2px'
                      }}
                      contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedId) ? "plaintext-only" : false}

                      type="text" id={"text" + props.index} value={props.original.id == undefined ? "" :
                        props.original.text} >{props.original.text}</div>
                  )
                },


                {
                  Header: <b>Action</b>,
                  width: 100,
                  sortable: false,
                  filterable: false,
                  Cell: props => {
                    return (
                      <div className="container-fluid" style={{ textAlign: "center" }}>
                        <img className="img-responsive" title={(props.original.id == undefined) ||
                          (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                          style={{ cursor: 'pointer', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }} src={
                            (props.original.id == undefined)
                              ?
                              this.saveImageSrc :

                              ((props.original.id
                                != this.state.editedId)
                                ?
                                this.editImageSrc : this.saveImageSrc)}
                          onClick={(e) => {
                            (this.state.data[props.index].id == undefined)
                              ?
                              this.saveOutgoingDialogDirApi(props, e)
                              :
                              ((this.state.data[props.index].id == this.state.editedId)
                                ?
                                this.updateOutgoingDialogDirApi(props, e)
                                :
                                this.editCell(props, e));

                          }}
                        />
                        <img src="assets/images/baseline_delete_white_24dp.png" title="Delete"
                          style={{ marginTop: '-48px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', cursor: "pointer", marginLeft: "15px" }}
                          onClick={() => {
                            (props.original.id) === undefined ?
                              this.fetchDialogDirAjax() :
                              this.setState({
                                hideDeletePopup: true,
                                propsId: props.original.id
                              })

                          }} />

                      </div>
                    )
                  }
                }
              ]}

              defaultPageSize={10}
              pageSizeOptions={[5, 10, 15]}
              style={{ backgroundColor: 'white' }}
            />
            <ToastContainer className="Toast-at-center" />




            {/*Dialog Component For Deletion Confirmation*/}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Dialog Directive' showCloseIcon={true} buttons={this.buttons}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideDeletePopup} close={this.dialogClose}>
              <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                content="" />&nbsp;Do you want to delete the Outgoing Dialog Directive?<br />Note: Press 'Yes' to delete or press 'No' to decline.

            </DialogComponent>

            {/* Dialog Component For  Delete All */}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Delete All' showCloseIcon={true} buttons={this.deleteAllButton}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideDeleteAllPopup} close={this.dialogClose}>
              <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                content="" />&nbsp;Do you want to delete all the Outgoing Dialog Directive?<br />Note: Press 'Yes' to delete or press 'No' to decline.
            </DialogComponent>

            {/*Dialog Component For  Delete input confirmation*/}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Delete Confirmation' showCloseIcon={true} buttons={this.textAreaConfir}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideTextAreaPopup} close={this.dialogClose}>
              Please type "Delete" for confirmation<input type="text" id="deleteInputFromUser" />
            </DialogComponent>

            {/*Dialog Component For  Incorrect Password*/}
            <DialogComponent width='400px' animationSettings={this.settings}
              header='Incorrect Password' showCloseIcon={true} buttons={this.incorrectPasswordButtons}
              ref={dialog => this.dialogInstance = dialog}
              visible={this.state.hideIncorrectPassword} close={this.IncorrectPassworddialogClose}>
              Please type "Delete"
            </DialogComponent>



          </div>
        </div>

      </div>

    )
  }
}
export default OutgoingDialogDirectives;


// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/Outgoing-Dialog-Directive.js